import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({ homeData : 'themes/getHomeData'}),
  },

  data() {},
  methods: {
    ...mapActions('videos', ['setCurrentTheme', 'setCurrentCategory']),
    itemClicked(themeId, category = 'trends') {


      eventHub.$emit('isVideoInfo');

      if (themeId === 0) {
        this.setCurrentCategory(category);
        this.$router.push({ name: 'home', params: { category } });
        return;
      }
      this.setCurrentTheme(themeId.toString());
      this.$router.push({ name: 'theme', params: { themeId } });
    },
    updateQueryStringParameter(uri, key, value) {
      var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
      var separator = uri.indexOf('?') !== -1 ? '&' : '?';
      if (uri.match(re)) {
        return uri.replace(re, '$1' + key + '=' + value + '$2');
      } else {
        return uri + separator + key + '=' + value;
      }
    },
    itemCategoryClicked(categoryId) {
      eventHub.$emit('isVideoInfo');

      let category = 'trends';
      let categories = this.homeData.filter(item => {
        return categoryId === item.id;
      });
      if (categories[0]) {
        category = categories[0].category;
        this.$router.push({ name: 'home', params: { category } });
      }
      this.setCurrentCategory(category);
      this.$router.push({ name: 'home', params: { category } });

    },
    makeToken() {
      var text = 'i';
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      for (var i = 0; i < 22; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      return text;
    },
  }
};



// WEBPACK FOOTER //
// ./src/mixins/Mixin.js